import { render, staticRenderFns } from "./api-modal.vue?vue&type=template&id=52eb821c&"
import script from "./api-modal.vue?vue&type=script&lang=js&"
export * from "./api-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports